const t = [
  "text",
  "json",
  "html",
  "markdown"
], T = [
  "start",
  "end",
  "all"
], _ = [
  "https",
  "http",
  "ftp",
  "ftps",
  "sftp",
  "mailto"
], s = {
  RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS: _,
  RICH_TEXT_EDITOR_OUTPUT_FORMATS: t,
  RICH_TEXT_EDITOR_AUTOFOCUS_TYPES: T
};
export {
  T as RICH_TEXT_EDITOR_AUTOFOCUS_TYPES,
  t as RICH_TEXT_EDITOR_OUTPUT_FORMATS,
  _ as RICH_TEXT_EDITOR_SUPPORTED_LINK_PROTOCOLS,
  s as default
};
//# sourceMappingURL=rich-text-editor-constants.js.map
